import ApiService from "@/core/services/api.service";
import Vue from "vue";

// action types
export const POPULATE_ACTIVITY_POLL_RESPONSES_LIST =
  "populateActivityPollRepsonsesList";
export const POPULATE_ACTIVITY_POLL_RESPONSES_INFO =
  "populateActivityPollRepsonsesInfo";
export const POPULATE_ACTIVITY_ADDITIONAL_POLL_RESPONSES_INFO =
  "populateActivityAdditionalPollRepsonsesInfo";
export const CREATE_POLL_RESPONSES = "createPollResponses";
export const UPDATE_POLL_RESPONSES = "updatePollResponses";
export const DELETE_POLL_RESPONSES = "deletePollResponses";
export const CLEAR_POLL_RESPONSES_LIST = "clearPollResponsesList";
export const CLEAR_POLL_RESPONSES_INFO = "clearPollResponsesInfo";
export const CLEAR_POLL_RESPONSES_ERRORS = "clearPollResponsesErrors";

// mutation types
export const SET_ACTIVITY_POLL_RESPONSES_LIST = "setActivityPollResponsesList";
export const RESET_ACTIVITY_POLL_RESPONSES_LIST =
  "resetActivityPollResponsesList";
export const SET_ACTIVITY_POLL_RESPONSES_INFO = "setActivityPollResponsesInfo";
export const RESET_ACTIVITY_POLL_RESPONSES_INFO =
  "resetActivityPollResponsesInfo";
export const APPEND_ACTIVITY_POLL_RESPONSES_LIST =
  "appendActivityPollResponsesInfo";
export const ADD_ACTIVITY_POLL_RESPONSES = "addActivityPollResponses";
export const UPDATE_ACTIVITY_POLL_RESPONSES = "updateActivityPollResponses";
export const REMOVE_ACTIVITY_POLL_RESPONSES = "removeActivityPollResponses";
export const SET_ACTIVITY_POLL_RESPONSES_ERRORS =
  "setActivityPollResponsesErrors";
export const RESET_ACTIVITY_POLL_RESPONSES_ERRORS =
  "resetActivityPollResponsesErrors";

const state = {
  activity_poll_responses_errors: {},
  activity_poll_responses_list: [],
  activity_poll_responses_info: []
};

const getters = {
  activityPollRepsonsesErrors(state) {
    return state.activity_poll_responses_errors;
  },
  activityPollRepsonsesList(state) {
    return state.activity_poll_responses_list;
  },
  activityPollRepsonsesInfo(state) {
    return state.activity_poll_responses_info;
  }
};

const actions = {
  [POPULATE_ACTIVITY_POLL_RESPONSES_LIST](context, payload) {
    return ApiService.get(
      "api/v1/activities/" + payload.activityId + "/activity_poll_responses",
      {
        params: payload.params
      }
    )
      .then(res => {
        const responses = res.data.data._embedded.activity_poll_responses;
        context.commit(SET_ACTIVITY_POLL_RESPONSES_LIST, responses);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [POPULATE_ACTIVITY_POLL_RESPONSES_INFO](context, payload) {
    return ApiService.get(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_poll_responses" +
        payload.activityPollResponseId,
      {
        params: payload.params
      }
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_POLL_RESPONSES_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [POPULATE_ACTIVITY_ADDITIONAL_POLL_RESPONSES_INFO](context, payload) {
    return ApiService.get(
      "api/v1/activities/" + payload.activityId + "/activity_poll_responses",
      {
        params: payload.params
      }
    )
      .then(res => {
        const responses = res.data.data._embedded.activity_poll_responses;
        context.commit(APPEND_ACTIVITY_POLL_RESPONSES_LIST, payload, responses);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CREATE_POLL_RESPONSES](context, payload) {
    return ApiService.post(
      "api/v1/activities/" + payload.activityId + "/activity_poll_responses",
      payload.data
    )
      .then(res => {
        context.commit(ADD_ACTIVITY_POLL_RESPONSES, res.data.data);
        return res.data.data;
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [UPDATE_POLL_RESPONSES](context, payload) {
    return ApiService.put(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_poll_responses" +
        payload.activityPollResponseId,
      payload.data
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_POLL_RESPONSES_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [DELETE_POLL_RESPONSES](context, payload) {
    return ApiService.delete(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_poll_responses/" +
        payload.id
    )
      .then(res => {
        Vue.$log.info("deleted");
        Vue.$log.info(res);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_POLL_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CLEAR_POLL_RESPONSES_LIST](context) {
    context.commit(RESET_ACTIVITY_POLL_RESPONSES_LIST);
  },
  [CLEAR_POLL_RESPONSES_INFO](context) {
    context.commit(RESET_ACTIVITY_POLL_RESPONSES_INFO);
  },
  [CLEAR_POLL_RESPONSES_ERRORS](context) {
    context.commit(RESET_ACTIVITY_POLL_RESPONSES_ERRORS);
  }
};

const mutations = {
  [SET_ACTIVITY_POLL_RESPONSES_LIST](state, activity_poll_responses_list) {
    state.activity_poll_responses_list = activity_poll_responses_list;
  },
  [RESET_ACTIVITY_POLL_RESPONSES_LIST](state) {
    state.activity_poll_responses_list = [];
  },
  [SET_ACTIVITY_POLL_RESPONSES_INFO](state, activity_poll_responses_info) {
    state.activity_poll_responses_info = activity_poll_responses_info;
  },
  [RESET_ACTIVITY_POLL_RESPONSES_INFO](state) {
    state.activity_poll_responses_info = [];
  },
  [ADD_ACTIVITY_POLL_RESPONSES](state, activity_poll_responses_info) {
    state.activity_poll_responses_list.push(activity_poll_responses_info);
  },
  [UPDATE_ACTIVITY_POLL_RESPONSES](state, activity_poll_responses_info) {
    let newActivityPollRepsonsesArray = [];
    newActivityPollRepsonsesArray.push(activity_poll_responses_info);
    state.activity_poll_responses_list = state.activity_poll_responses_list.map(
      obj => newActivityPollRepsonsesArray.find(o => o.id === obj.id) || obj
    );
  },
  [APPEND_ACTIVITY_POLL_RESPONSES_LIST](
    state,
    payload,
    activity_poll_responses_additional_list
  ) {
    let responseToIndex = state.activity_poll_responses_list.findIndex(
      p => p.id == payload.responding_to
    ); // to be update
    if (responseToIndex !== -1) {
      state.activity_poll_responses_list = state.activity_poll_responses_list.splice(
        responseToIndex,
        0,
        activity_poll_responses_additional_list
      );
    } else {
      state.activity_poll_responses_list.push(
        activity_poll_responses_additional_list
      );
    }
  },
  [REMOVE_ACTIVITY_POLL_RESPONSES](state, activityPollResponseId) {
    state.activity_poll_responses_list = state.activity_poll_responses_list.filter(
      function(obj) {
        return obj.id !== activityPollResponseId;
      }
    );
  },
  [SET_ACTIVITY_POLL_RESPONSES_ERRORS](state, activity_poll_responses_errors) {
    state.activity_poll_responses_errors = activity_poll_responses_errors;
  },
  [RESET_ACTIVITY_POLL_RESPONSES_ERRORS](state) {
    state.activity_poll_responses_errors = [];
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
